module.exports = __webpack_public_path__ + "img/thePublic.f955f5e0.png";